import { api } from "@/lib/api";

let ctx;
export const unlockAudio = () => {
  try { ctx = ctx || new (window.AudioContext || window.webkitAudioContext)(); if (ctx.state === "suspended") ctx.resume(); } catch (e) { ctx = null; }
};

export const playAlert = (rounds = 3) => {
  navigator.vibrate?.([400, 150, 400, 150, 800]);
  if (!ctx) return;
  const t0 = ctx.currentTime + 0.05;
  for (let i = 0; i < rounds * 2; i += 1) {
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = "square";
    o.frequency.value = i % 2 ? 1320 : 880;
    const t = t0 + i * 0.32;
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(0.35, t + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.25);
    o.connect(g).connect(ctx.destination);
    o.start(t);
    o.stop(t + 0.27);
  }
};

const bytes = (v) => {
  const raw = atob((v + "=".repeat((4 - (v.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);
export const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

export async function currentSub() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration("/");
  return reg ? reg.pushManager.getSubscription() : null;
}

export async function enablePush() {
  unlockAudio();
  if (!pushSupported()) throw new Error(isIOS() ? "On iPhone, add this app to your Home Screen first (Share, then Add to Home Screen), open it from the icon, then turn alerts on." : "This browser can't show notifications.");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notifications are blocked. Allow them for this site in your phone settings.");
  const reg = await navigator.serviceWorker.register("/sw.js", { scope: "/" });
  await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { data } = await api.get("/push/public-key");
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: bytes(data.key) });
  }
  await api.post("/push/subscriptions", sub.toJSON());
  return sub;
}

export async function disablePush() {
  const sub = await currentSub();
  if (sub) { await api.delete("/push/subscriptions", { data: { endpoint: sub.endpoint } }).catch(() => {}); await sub.unsubscribe(); }
}

export async function refreshPush() {
  if (!pushSupported() || Notification.permission !== "granted") return;
  const reg = await navigator.serviceWorker.register("/sw.js", { scope: "/" });
  const sub = await reg.pushManager.getSubscription();
  if (sub) api.post("/push/subscriptions", sub.toJSON()).catch(() => {});
}
